// TODO: rethink where does this selector fit (a router service?)

export const getRouter = (state) => state.router
export const getRouterLocation = (state) => state.router.location
export const getRouterPathname = (state) => state.router.location.pathname
export const getRouterQueries = (state) => state.router.location.query
export const getRouterSearch = (state) => state.router.location.search
